import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as micropython from './micropython';
import * as zephyr from './zephyr';
import * as tios from './tios';
import * as simulator from './simulator';


export default class CggTelemetryNode extends BaseNode {
    constructor() {
        super();
        this.name = 'AppBlocks Cloud Metric';
        this.id = 'node_cgg_telemetry';
        this.linkedFeature = 'cgg';
        this.requirements = ['network'];

        this.inputs = [
            {
                name: 'Send',
                portId: 'cgg_pub',
                params: [
                    {
                        name: 'event_name',
                        dataType: TibboDataType.STRING,
                    },
                    {
                        name: 'publish_data',
                        dataType: TibboDataType.STRING,
                    },
                ],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/phm/wm2000ev_demo_03';
    }
}
